// Helper functions for the campaign grid

// Just because the string is long otherwise
export const getProductId = (page, blockId) => `${page}page${blockId}`;

// Check if box is disabled
export const isDisabled = (products, page, blockId) => {
  const product = products[getProductId(page, blockId)];
  return product?.name === 'DO NOT USE - Product Needs Multiple Boxes';
};

export const getBackgroundColor = (selected, blockId, products, page) => {
  if (selected === blockId) return '#a73c21';
  if (isDisabled(products, page, blockId)) return '#4a4a4a';
  return '#dedede';
};

export const getDisplayText = (products, page, blockId) => {
  const productId = getProductId(page, blockId);
  if (!(productId in products)) return "Select Box";
  
  const name = products[productId].name;
  return name !== "" ? name : "MISSING PRINT NAME";
};